import { animateCursorClick, animateCursorMove } from 'modules/ai_voice/lib/cursor'
import { dispatchClick, dispatchType, scrollIntoView } from 'modules/ai_voice/lib/dom'
import { type FindElementOptions, findElement } from 'modules/ai_voice/lib/find-element'

export async function click({ options }: { options: FindElementOptions }): Promise<void> {
  const element = await findElement(options)
  await scrollIntoView(element)
  await animateCursorMove(element, 'center')
  dispatchClick(element)
  await animateCursorClick()
}

export async function type({
  options,
  text,
}: {
  options: FindElementOptions
  text: string
}): Promise<void> {
  // eslint-disable-next-line
  const element = (await findElement(options)) as HTMLInputElement
  await scrollIntoView(element)
  await animateCursorMove(element, 'right')
  await dispatchType(element, text)
}
